/* OsPlanDetailsViewComponent.js */

"use strict";
const _ = require("lodash");
const PlatformSdk = require("@gluenetworks/platform-sdk-remote");
const OsUpgradePlanEntity = PlatformSdk.entities.ws.OsUpgradePlan;
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsPlanDetailsViewRenderer");
const PagingOsPlanDetailsFeed = require("./PagingOsPlanDetailsFeed");
const PagingOsPlanDeviceFeed = require("../../../../lmrbcomponents/deviceexplorer/views/device_grid_view/PagingDeviceFeed");
const LinksColumn = require("./column_renderers/links/LinksComponent");
const TargetFilesColumn = require("./column_renderers/target_files/TargetFilesComponent");
const ProtocolColumn = require("./column_renderers/protocol/ProtocolComponent");
const Registrations = require("../../../../../RegistrationNamespaces");
const editImagesView = require("./subviews/image_details/ImageDetailsComponent");
const childViewComponent = require("../../../../widgets/childview/ChildViewRenderer");
const DEFAULT_SORT = {detectedSku: 1};
class OsPlanDetailsViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        MUF,
        steveIo,
        osImageCatalog,
        OsImage,
        OsUpgradePlanPrefs,
        storageFactory,
        OsImageServerPrefs,
        VendorApiConfig,
        OsUpgradeOptions,
        ValueMapEntity
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._userSession = userSession;
        this._steveIo = steveIo;
        this._pagingRelatedFeed = undefined;
        this._plan = undefined;
        this._groupBy = undefined;
        this._gridKey = "plan_planDetails";
        this._isScheduled = undefined;
        this._osImageCatalogEntity = osImageCatalog;
        this._osImageEntity = OsImage;
        this._osUpgradePrefs = OsUpgradePlanPrefs;
        this._validateWorkId = undefined;
        this._isCiscoEnabled = undefined;
        this._isVendorApiImageCheckEnabled = undefined;
        this._osImageServerPrefs = OsImageServerPrefs;
        this._osImageServerPrefsEntity = undefined;
        this._VendorApiConfigEntityDef = VendorApiConfig;
        this._ValueMapEntity = ValueMapEntity;
        this._OsUpgradeOptionsEntity = OsUpgradeOptions;
        this._storageFactory = storageFactory;
        this._deviceFeedSystemQuery = {managementState: {$in: ["MANAGED"]}};
        this._switchToEditImage = _.debounce(this._switchToEditImage, 1000, {
            leading: true,
            trailing: false,
        });
        this.columnConfig = {
            grouping: {
                label: "Group",
                width: 200,
                shown: false,
                entityColumn: true,
                isGroupingColumn: true,
                sortable: true,
                priority: 0,
            },
            detectedVendor: {
                label: "Vendor",
                width: 100,
                sortable: true,
                priority: 1,
            },
            detectedSku: {
                label: "SKU",
                width: 100,
                sortable: true,
                priority: 2,
                groupable: true,
            },
            name: {
                label: "Device",
                width: 250,
                sortable: true,
                priority: 3,
            },
            detectedOs: {
                label: "Current OS",
                width: 120,
                sortable: true,
                priority: 4,
            },
            detectedSoftwareVersion: {
                label: "Current OS Version",
                width: 150,
                sortable: true,
                priority: 5,
            },
            imageAssociations: {
                label: "Target Files",
                width: 300,
                sortable: false,
                priority: 6,
                entityColumn: true,
                isCombinedColumn: true,
                columnRendererComponent: TargetFilesColumn,
                context: {
                    gameEditor: this._gameEditor,
                    logger: this._logger,
                    modalUserFeedback: this._modalUserFeedback,
                    osImageCatalog: this._osImageCatalogEntity,
                    osImage: this._osImageEntity,
                    osPlanDetailsViewModel: this,
                    osUpgradePrefs: this._osUpgradePrefs,
                    switchToEditImage: this._switchToEditImage,
                },
            },
            protocol: {
                label: "Protocol",
                width: 80,
                isCombinedColumn: true,
                sortable: false,
                entityColumn: true,
                columnRendererComponent: ProtocolColumn,
                priority: 7,
                context: {
                    gameEditor: this._gameEditor,
                    logger: this._logger,
                    modalUserFeedback: this._modalUserFeedback,
                    osImageCatalog: this._osImageCatalogEntity,
                    osImage: this._osImageEntity,
                    osPlanDetailsViewModel: this,
                    osUpgradePrefs: this._osUpgradePrefs,
                    switchToEditImage: this._switchToEditImage,
                },
            },
            action: {
                label: "Action",
                sortable: false,
                priority: 8,
                width: 150,
                columnRendererComponent: LinksColumn,
                context: {
                    gameEditor: this._gameEditor,
                    logger: this._logger,
                    modalUserFeedback: this._modalUserFeedback,
                    osImageCatalog: this._osImageCatalogEntity,
                    osImage: this._osImageEntity,
                    osPlanDetailsViewModel: this,
                    osUpgradePrefs: this._osUpgradePrefs,
                    switchToEditImage: this._switchToEditImage,
                },
                entityColumn: true,
                isCombinedColumn: true,
                isLockedRight: true,
            },
        };
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerPlanListeners() {
        this._plan.on(
            "DirtyStateChanged",
            (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this))
        );
        this._plan.on(
            "PendingPatchesChanged",
            (this._onPendingPatchesChanged = this._onPendingPatchesChanged.bind(this))
        );
        this._plan.on(
            "PristinePropertiesChanged",
            (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this))
        );
    }

    _unregisterPlanListeners() {
        this._plan.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
        this._plan.removeListener("PendingPatchesChanged", this._onPendingPatchesChanged);
        this._plan.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get steveIo() {
        return this._steveIo;
    }

    getPlan() {
        return this._plan;
    }

    get plan() {
        return this.getPlan();
    }

    set plan(newPlan) {
        this._plan = newPlan;
        return true;
    }
    get gameEditorRootElement() {
        return this._gameEditor.renderer._rootElem;
    }

    /*** Game Editor ***/
    get gameEditor() {
        return this.getGameEditor();
    }

    getGameEditor() {
        return this._gameEditor;
    }
    get groupBy() {
        return this._groupBy;
    }

    set groupBy(newvalue) {
        this._groupBy = newvalue;
        return true;
    }

    get defaultSort() {
        // clone: PagingFeed.setSort() keeps the reference it is given
        return _.clone(DEFAULT_SORT);
    }

    shutdown() {
        this._unregisterListeners();
        this._unregisterPlanListeners();
        // cancel the pending debounce timer so it cannot fire against torn-down state
        if (this._switchToEditImage && _.isFunction(this._switchToEditImage.cancel)) {
            this._switchToEditImage.cancel();
        }
        return this._renderer
            .shutdown()
            .then(() => {
                if (this._pagingRelatedFeed) {
                    return this._pagingRelatedFeed.shutdown();
                }
                return Promise.resolve();
            })
            .then(() => {
                if (this._pagingDeviceFeed) {
                    return this._pagingDeviceFeed.shutdown();
                }
                return Promise.resolve();
            })
            .then(
                () => {
                    // constructor-injected deps
                    this._modalUserFeedback = undefined;
                    this._userSession = undefined;
                    this._steveIo = undefined;
                    this._logger = undefined;
                    this._gameEditor = undefined;
                    this._storageFactory = undefined;
                    this._osImageCatalogEntity = undefined;
                    this._osImageEntity = undefined;
                    this._osUpgradePrefs = undefined;
                    this._osImageServerPrefs = undefined;
                    this._VendorApiConfigEntityDef = undefined;
                    this._ValueMapEntity = undefined;
                    this._OsUpgradeOptionsEntity = undefined;
                    this._switchToEditImage = undefined;

                    // owned components / feeds
                    this._renderer = undefined;
                    this._pagingRelatedFeed = undefined;
                    this._pagingDeviceFeed = undefined;

                    // columnConfig contexts hold refs back to gameEditor/logger/this — must drop
                    this.columnConfig = undefined;

                    // model / runtime state
                    this._plan = undefined;
                    this._groupBy = undefined;
                    this._isScheduled = undefined;
                    this._isDirty = undefined;
                    this._validateWorkId = undefined;
                    this._deviceFeedSystemQuery = undefined;
                    this._osImageServerPrefsEntity = undefined;
                    this._isCiscoEnabled = undefined;
                    this._isVendorApiImageCheckEnabled = undefined;
                    this._osmOptionEntities = undefined;
                    this._vendorOsMap = undefined;
                    this._planExecutionEntity = undefined;
                    this._userHasosmImageValidationOverride = undefined;
                    this._planCanBeReset = undefined;

                    return Promise.resolve();
                },
                (err) => {
                    this._logger.warn(err, "OsPlanDetailsViewComponent.shutdown() error.");
                }
            );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDirtyStateChanged(dirtyState) {
        if (!_.isNull(this._plan._pendingPatches)) {
            dirtyState = true;
            this._gameEditor.getTabCmpnt().setDirty(dirtyState);
        }

        this.emit("Dirty", dirtyState);

        let onBeforeUnloadFunc = () => {
            return this._modalUserFeedback
                .displayConfirmation("Would you like to Save or Discard your changes?", {
                    title: "Unsaved Changes",
                    confirmDetails: {
                        text: "Save",
                        type: "additive",
                    },
                    rejectDetails: {
                        text: "Discard",
                        type: "text",
                    },
                })
                .then(() => {
                    if (this.isPlanFormValid(true)) {
                        return this.savePlan().then(() => undefined); // it will not close the tab if it will have something in result
                    }
                })
                .catch((err) => {
                    if (err.userRejected) {
                        return Promise.resolve(this._plan.clearPendingPatches(true))
                            .then(() => this._modalUserFeedback.hideDisplayed())
                            .then(() => {
                                this._isDirty = false;
                                this._gameEditor.getTabCmpnt().setDirty(false);
                            })
                            .then(() => undefined);
                    } else {
                        console.error("Error in onBeforeUnloadFunc! Err:", err);
                    }
                });
        };
        if (this.isDirty()) {
            this._gameEditor.setOnBeforeUnload(onBeforeUnloadFunc);
        } else {
            this._gameEditor.clearOnBeforeUnload();
        }
    }

    _onPendingPatchesChanged() {
        // TODO - this is a quick hack because the Array ref adapter does a shutdown and complete rebuild every time you call setValue. the effect to the user is they lose focus in the proxy list if they stop typing longer than the debounce
        // this.emit('PolicyPropertiesChanged');
    }

    async _onPristinePropertiesChanged(pristineProperties, before) {
        if (this._plan.deviceCount !== pristineProperties.deviceCount) {
            this._plan.setProperty("deviceCount", pristineProperties.deviceCount);
        }
        try {
            if (pristineProperties.status !== before.status) {
                if (["CANCELED", "COMPLETE", "ERROR"].indexOf(pristineProperties.status) >= 0) {
                    await this.getPlanExecutionEntity();
                }
            }
        } catch (err) {
            this._logger.warn("PristinePropertiesChanged :: err :: " + err);
        } finally {
            this.emit("PlanPropertiesChanged", pristineProperties, before);
        }
    }

    _switchToEditImage() {
        let editImages = new editImagesView(
            this._logger,
            this._gameEditor,
            {configExecutionEntity: this._value},
            this._steveIo,
            this._context.osImageCatalog,
            this._context.osImage,
            this._context.osUpgradePrefs,
            this._osPlanDetailsViewModel._userSession,
            this._osPlanDetailsViewModel._osImageServerPrefsEntity
        );
        editImages.renderer.render().then(() => {
            this._gameEditor._activeView.childViewOpen = true;
            this._childViewRenderer = new childViewComponent({
                data: editImages.renderer.rootElement,
                backLink: "Details",
                title: "Edit Files",
                childData: editImages,
                parentData: this._gameEditor._activeView,
                backButton: true,
            });
            this._gameEditor.hideViewAction("ValidationLogs");
        });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _clearImageAssociationVeil(groupedValue) {
        if (groupedValue === "detectedSku") {
            return this._modalUserFeedback
                .displayConfirmation(
                    "Are you sure you want to change how devices are grouped? This will permanently delete all existing image associations?",
                    {
                        title: "Group Devices",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    }
                )
                .then(() => {
                    return this._plan.clearAllImageAssociations();
                })
                .then(() => {
                    this.emit("Dirty", false);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        } else {
            return this._plan
                .ungroup()
                .then(() => {
                    this.emit("Dirty", false);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        }
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    isDirty() {
        return this._plan.isDirty();
    }

    get logger() {
        return this._logger;
    }
    get isScheduled() {
        return this._isScheduled;
    }

    get isOsUpgradeAutoCaptured() {
        return this._gameEditor.isOsUpgradeAutoCaptured;
    }

    get isOsTransferAutoCaptured() {
        return this._gameEditor.isOsTransferAutoCaptured;
    }

    set isScheduled(newValue) {
        this._isScheduled = newValue;
        return true;
    }

    getOsUpgradeOptions() {
        this._OsUpgradeOptionsEntity
            .loadOsUpgradeOptions(this._gameEditor.activeOrgId)
            .then((optionEntities) => {
                this._osmOptionEntities = optionEntities;
            });
    }
    getVendorOsMap() {
        this._ValueMapEntity.loadVendorOsMapEntity(this._gameEditor.activeOrgId).then((entity) => {
            this._vendorOsMap = entity;
            return entity;
        });
    }

    getPlanExecutionEntity() {
        return this._plan.loadRelatedExecution().then((entity) => {
            this._planExecutionEntity = entity;
            return Promise.resolve();
        });
    }

    whenModelIsReady() {
        return Promise.resolve()
            .then(() => {
                return Promise.all([this.getOsUpgradeOptions(), this.getVendorOsMap()]);
            })
            .then(() => this._gameEditor.whenPlanIsReady())
            .then(() => OsUpgradePlanEntity.getOsUpgradeDeviceQuery(this._gameEditor.activeOrgId))
            .then((result) => {
                if (_.isEmpty(result)) {
                    this._deviceFeedSystemQuery = {
                        $and: [
                            {
                                discoveryStatus: "DISCOVERED",
                            },
                            {
                                managementState: "MANAGED",
                            },
                        ],
                    };
                } else {
                    this._deviceFeedSystemQuery = result;
                }
                this._plan = this.gameEditor.getPlan();
                this._groupBy = this._plan.groupedBy;
                this._pagingRelatedFeed = this._createFeed(this._plan);
                this._pagingDeviceFeed = this._createDeviceFeed();
                const userAuthActions = _.get(this._userSession, "authorizedActions", []);
                this._userHasosmImageValidationOverride =
                    userAuthActions.indexOf("osmImageValidationOverride") >= 0;
                return this._VendorApiConfigEntityDef.loadVendorApiConfig(
                    this._gameEditor.activeOrgId
                );
            })
            .then((vendorApiConfig) => {
                // console.log(vendorApiConfig);
                this._isCiscoEnabled = _.get(
                    vendorApiConfig,
                    "properties.vendors.cisco.enabled",
                    false
                );
                return this._osUpgradePrefs.loadPrefs(this._gameEditor.activeOrgId);
            })
            .then((osUpgradePrefs) => {
                // console.log(osUpgradePrefs);
                this._isVendorApiImageCheckEnabled = !_.get(
                    osUpgradePrefs,
                    "properties.skipCiscoApiImageChecks",
                    false
                );
                this._planCanBeReset =
                    this._plan.status === "COMPLETE" &&
                    this._plan.deviceCount === this._plan.deviceFailureCount &&
                    _.get(osUpgradePrefs, "properties.allowMultipleExecutions", false);
                return this._osImageServerPrefs.retrieveAscendOsImageServerPrefs(
                    this._gameEditor.activeOrgId
                );
            })
            .then((osServerPrefEntity) => {
                this._osImageServerPrefsEntity = osServerPrefEntity;
                this._registerPlanListeners();
                return Promise.all([
                    this._pagingRelatedFeed.whenFeedReady(),
                    this._pagingDeviceFeed.whenFeedReady(),
                ]);
            })
            .then(() => {
                if (
                    this._plan &&
                    ["CANCELED", "COMPLETE", "ERROR"].indexOf(this._plan.status) >= 0
                ) {
                    return this.getPlanExecutionEntity();
                }
                return Promise.resolve();
            })
            .then(() => {
                return this._plan.loadPlanSchedule();
            })
            .then((scheduled) => {
                if (scheduled) {
                    this._isScheduled = true;
                } else {
                    this._isScheduled = false;
                }
            })
            .catch((err) => {
                this._logger.warn(err, "OsPlanDetailsViewComponent.whenModelIsReady() error");
                this._modalUserFeedback.displayError({
                    errorMsg: "This plan cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }
    resetPlanProperties() {
        this._plan.clearPendingPatches();
        return Promise.resolve();
    }

    isPlanFormValid(rollbackInvalidData = false) {
        const plan = this._plan;
        const inputChanges = plan.getProperties();
        const oldData = plan.getPristineProperties();
        const inputDataName = inputChanges.name.trim();
        const isInputNameEmpty = inputDataName.length === 0;

        if (isInputNameEmpty && rollbackInvalidData === false) {
            throw {
                errorMsg: "Name cannot be left empty. Please enter a valid plan name.",
                errorCode: "SyntaxError",
                title: "Error",
            };
        } else if (isInputNameEmpty && rollbackInvalidData === true) {
            plan.setName(oldData.name.trim());
            return true;
        } else {
            plan.setName(inputDataName);
            return true;
        }
    }

    savePlan() {
        return Promise.resolve()
            .then(() => {
                //do nothing unless this guy is dirty
                if (this._plan.isDirty()) {
                    this.isPlanFormValid();
                    return this._plan.update();
                }
            })
            .then((entity) => {
                this._plan.clearPendingPatches();
                return Promise.resolve(entity);
            })
            .catch((err) => {
                this._logger.warn({error: err}, "OsPlanDetailsViewComponent.savePlan() error.");
                if (err.errorCode === "NoPendingUpdates") {
                    this.emit("RefreshPlanDetails");
                    return Promise.reject();
                } else {
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _cancelScheduler() {
        return Promise.resolve()
            .then(() => {
                return this._plan.removePlanSchedule();
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "OsPlanDetailsViewComponent._cancelScheduler() error."
                );
                return Promise.reject();
            });
    }

    _switchView(switchTo) {
        this._gameEditor.setActiveView(switchTo, [
            {
                value: {
                    fqn: Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
                    viewState: {plan: this._plan},
                },
                content: "Details",
                left: {
                    arrow: {
                        direction: "left",
                    },
                },
            },
        ]);
    }

    _cancelRemaining() {
        return Promise.resolve()
            .then(() => {
                return this._plan.cancelPlanWork(this._workId);
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "OsPlanResultsViewComponent._cancelRemaining() error."
                );
                return Promise.reject();
            });
    }

    onUserSorted(sortData) {
        let sort = {};
        [].concat(sortData).forEach((entry) => {
            if (!entry || !entry.sortColumn || !this.columnConfig[entry.sortColumn]) {
                return;
            }
            sort[entry.sortColumn] = entry.sort === "asc" ? 1 : -1;
        });
        if (_.isEmpty(sort)) {
            sort = this.defaultSort;
        }
        this._pagingRelatedFeed.setSort(sort);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/

    _createFeed(entity) {
        return new PagingOsPlanDetailsFeed({
            feedKey: this._gridKey + "_feed",
            userSession: this._userSession,
            entityDef: entity,
            columnConfig: this.columnConfig,
            // default is 50, but setting to 100 means most lists wont need any paging
            // new speedups make larger page size viable for these lists
            pageSize: 100,
            sort: {
                detectedSku: 1,
            },
            filter: {},
        });
    }

    _createDeviceFeed() {
        let filterQuery = {
            $userQuery: {},
            $systemQuery: this._deviceFeedSystemQuery,
        };
        return new PagingOsPlanDeviceFeed({
            activeOrgId: this._gameEditor.activeOrgId,
            entityDef: this._gameEditor.getDeviceEntity(),
            feedKey: this._gridKey + "_feed",
            columnConfig: undefined,
            pageSize: this._pageSize,
            sort: {name: 1},
            filter: filterQuery,
        });
    }
}

module.exports = OsPlanDetailsViewComponent;

OsPlanDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.io",
    "$teve.entities.OsImageCatalog",
    "$teve.entities.OsImage",
    "$teve.entities.OsUpgradePlanPrefs",
    "$teve.storageFactory",
    "$teve.entities.OsImageServerPrefs",
    "$teve.entities.VendorApiConfig",
    "$teve.entities.OsUpgradeOptions",
    "$teve.entities.ValueMap",
];

OsPlanDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "OS Plan Details",
    icon: "osmanager.edit_os_plan",
    shown: true,
    title: "Details",
    order: 1,
};
